import React, { useEffect, useState } from 'react';
import { Box, Typography, TextField, Button, Avatar, Link, InputAdornment, BaseTextFieldProps, MenuItem, Select, IconButton, FormControlLabel, Checkbox, CheckboxProps } from '@mui/material';
import { author, avtarLadyImg, founder, jessicaImg, leftBg, loader } from '../../assets/images';
import { EasyWebinarLogo, EmailIcon, NameIcon, ProtectionIcon } from '../../assets/icons';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { usePhoneInput, defaultCountries, CountryIso2, FlagImage, parseCountry } from 'react-international-phone';
import AccountVerification from '../modals/AccountVerification';


export interface MUIPhoneProps extends BaseTextFieldProps {
    value: string;
    onChange: (phone: string) => void;
}

export const MuiPhone: React.FC<MUIPhoneProps> = ({
    value,
    onChange,
    ...restProps
}) => {
    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
        usePhoneInput({
            defaultCountry: 'us',
            value,
            countries: defaultCountries,
            onChange: (data) => {
                onChange(data.phone);
            },
        });

    return (
        <TextField
            variant="outlined"
            color="primary"
            placeholder="Phone number"
            value={inputValue}
            onChange={handlePhoneValueChange}
            type="tel"
            inputRef={inputRef}
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: '3px',
                    borderColor: '#666666',
                },

                " .MuiInputLabel-root.Mui-focused": {
                    color: "inherit",
                },

                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: '#333333',
                    border: '1px solid'
                },

                "& .MuiOutlinedInput-input": {
                    padding: '11px 11px 11px 0px',
                    background: '#ffffff',
                    borderRadius: '8px'
                },
                "&.MuiInputBase-input::placeholder": {
                    color: '#333333',
                    fontSize: '16px',
                    opacity: '0.8'
                },
            }}

            slotProps={{
                input: {
                    startAdornment: <InputAdornment
                        position="start"
                        style={{ marginRight: '2px', marginLeft: '-8px' }}
                    >
                        <Select
                            MenuProps={{
                                style: {
                                    height: '300px',
                                    width: '360px',
                                    top: '10px',
                                    left: '-34px',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                            }}
                            sx={{
                                width: 'max-content',
                                fieldset: {
                                    display: 'none',
                                },
                                '&.Mui-focused:has(div[aria-expanded="false"])': {
                                    fieldset: {
                                        display: 'block',
                                    },
                                },
                                '.MuiSelect-select': {
                                    padding: '8px',
                                    paddingRight: '24px !important',
                                },
                                svg: {
                                    right: 0,
                                },
                            }}
                            value={country.iso2}
                            onChange={(e) => setCountry(e.target.value as CountryIso2)}
                            renderValue={(value) => (
                                <FlagImage iso2={value} style={{ display: 'flex' }} />
                            )}
                        >
                            {defaultCountries.map((c) => {
                                const country = parseCountry(c);
                                return (
                                    <MenuItem key={country.iso2} value={country.iso2}>
                                        <FlagImage
                                            iso2={country.iso2}
                                            style={{ marginRight: '8px' }}
                                        />
                                        <Typography marginRight="8px">{country.name}</Typography>
                                        <Typography color="gray">+{country.dialCode}</Typography>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </InputAdornment>
                },
            }}
            {...restProps}
        />
    );
};

const EasyWebinarsignUp = () => {
    const [phone, setPhone] = useState('');
    const [showPassword, setShowPassword] = React.useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [step, setStep] = useState(1);

    const handleNext = () => {
        if (step === 1) {
            handleDialogOpen();
        } else {
            setStep(step + 1);
        }
    };


    const handleProceed = () => {
        handleDialogClose();
        setStep(step + 1);
    };


    const handleBack = () => setStep((prevStep) => (prevStep > 1 ? prevStep - 1 : prevStep));

    const [dialogOpen, setDialogOpen] = React.useState(false);

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);

    };

    const cards = [
        {
            testimonial:
                "\"I've been using EasyWebinar for over five years now for all of my evergreen webinars. I'm a fan for life not only because my webinars are more profitable due to their cutting-edge features, but also because of their impeccable customer support. I tell all my students about EasyWebinar because I know they will be in good hands!\"",
            name: "Amy Porterfield",
            title: "Online Marketing Expert",
            avatar: avtarLadyImg,
        },
        {
            testimonial:
                "\"With EasyWebinar you understand the people you're serving - which means you're thinking of the things they need. It's not just flashy software, it's what is important and what is vital for someone to grow their business.\"",
            name: "Jessica Catorc & Andrew Guttormsen",
            title: "Teachable",
            avatar: jessicaImg,
        },
        {
            testimonial:
                "\"The name is completely self-explanatory. Easiest integrations, best customer service, and EASY to use.\"",
            name: "Susie Moore",
            title: "Susie Moore",
            avatar: founder,
        },
        {
            testimonial:
                "\"We made 2 million dollars using EasyWebinar. We created one webinar, one time, and ran it for 3 years. We went from needing 6 sales reps to only 1 'order taker' using EasyWebinar as the sales engine.\"",
            name: "Ryan Fenn",
            title: "CEO and Founder of Chiirp",
            avatar: author,
        },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % cards.length);
        }, 1500);

        return () => clearInterval(interval);
    }, [cards.length]);

    const handleDotClick = (index: any) => {
        setCurrentIndex(index);
    };

    const BpIcon = styled('span')(({ theme }) => ({
        borderRadius: 4,
        width: 21,
        height: 21,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#fff',

        'input:hover ~ &': {
            border: '1px solid #666666',
        },
    }));

    const BpCheckedIcon = styled(BpIcon)({
        '&::before': {
            display: 'block',
            width: 21,
            height: 21,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fillRule='evenodd' clipRule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input ~ &': {
            backgroundColor: '#22B060',
            border: 'none',
        },

        'input:hover ~ &': {
            border: 'none',
        }
    });

    function BpCheckbox(props: CheckboxProps) {
        return (
            <Checkbox
                sx={{ '&:hover': { bgcolor: 'transparent' } }}
                disableRipple
                color="default"
                checkedIcon={<BpCheckedIcon />}
                icon={<BpIcon />}
                {...props}
            />
        );
    }

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };


    const handlePhoneChange = (value: string) => {
        setPhone(value);
    };

    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 5,
        borderRadius: 27,
        [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: "#E8E8EA",
        },
        [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 27,
            backgroundColor: '#22B060',
        },
    }));

    return (
        <Box
            sx={{
                margin: 0,
                padding: 0,
                backgroundColor: '#f5f5f5',
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: '0px 4px 24px 0px #0000001A',
            }}
        >
            <Box
                sx={{
                    backgroundColor: '#fff',
                    borderRadius: { xs: "0", md: "23px" },
                    boxShadow: { xs: "none", md: "0 4px 8px rgba(0, 0, 0, 0.1)" },
                    display: 'flex',
                    maxWidth: '1369px',
                    width: '100%',
                    overflow: 'hidden',
                    border: { xs: "none", md: "1px solid #A3A3A3" },
                    margin: { xs: '0px', md: '87px' },
                    flexWrap: 'wrap'

                }}
            >
                <Box
                    sx={{
                        backgroundColor: '#f9f9f9',
                        padding: { xs: '14px 24px', sm: '30px 21px', lg: '49px 66px' },
                        flex: 1,
                        width: '50%',
                        textAlign: 'center',
                        backgroundImage: `url(${leftBg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        '@media (max-width: 768px)': {
                            width: '100%',
                            order: 2,
                        }
                    }}
                >
                    <Box
                        sx={{
                            display: "block",
                            "& svg": {
                                height: "43px",
                            },
                            "@media (max-width: 768px)": {
                                display: "none",
                            },

                        }}
                    >
                        <EasyWebinarLogo />
                    </Box>
                    <Typography variant="h5" fontSize="min(calc(20px + 4 * (100vw - 400px) / (1920 - 400)), 24px)" sx={{ color: '#000000', m: { xs: "0 0px 24px 0", md: "24px" }, fontWeight: '600' }}>
                        Your <span style={{ color: '#4CAF50', fontWeight: '800', fontStyle: 'italic' }}>Free Trial</span> of Pro plan includes
                    </Typography>
                    <Box display="flex" flexWrap="wrap">
                        <Box width={{ xs: "100%", xl: "55%" }}>
                            <Box display="flex" gap="10px" mb="13px">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.416 5.25759L6.67448 13.9991L2.66797 9.99257L3.69509 8.96544L6.67448 11.9375L14.3888 4.23047L15.416 5.25759Z" fill="#0C0C0D" />
                                </svg>
                                <Typography color='#111111' fontSize="13px" fontWeight="700">Up to 25 leads</Typography>
                            </Box>
                            <Box display="flex" gap="10px" mb="13px">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.416 5.25759L6.67448 13.9991L2.66797 9.99257L3.69509 8.96544L6.67448 11.9375L14.3888 4.23047L15.416 5.25759Z" fill="#0C0C0D" />
                                </svg>
                                <Typography color='#111111' fontSize="13px" fontWeight="700">1 Active live webinar</Typography>
                            </Box>
                            <Box display="flex" gap="10px" mb="13px">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.416 5.25759L6.67448 13.9991L2.66797 9.99257L3.69509 8.96544L6.67448 11.9375L14.3888 4.23047L15.416 5.25759Z" fill="#0C0C0D" />
                                </svg>
                                <Typography color='#111111' fontSize="13px" fontWeight="700">1 Active Automated Webinar</Typography>
                            </Box>
                            <Box display="flex" gap="10px" mb="13px">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.416 5.25759L6.67448 13.9991L2.66797 9.99257L3.69509 8.96544L6.67448 11.9375L14.3888 4.23047L15.416 5.25759Z" fill="#0C0C0D" />
                                </svg>
                                <Typography color='#111111' fontSize="13px" fontWeight="700">Up to 10 Live webinar Attendees</Typography>
                            </Box>
                            <Box display="flex" gap="10px" mb="13px">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.416 5.25759L6.67448 13.9991L2.66797 9.99257L3.69509 8.96544L6.67448 11.9375L14.3888 4.23047L15.416 5.25759Z" fill="#0C0C0D" />
                                </svg>
                                <Typography color='#111111' fontSize="13px" fontWeight="700" textAlign="start">Up to 10 Automated webinar Attendees</Typography>
                            </Box>
                        </Box>
                        <Box width={{ xs: "100%", xl: "45%" }}>
                            <Box display="flex" gap="10px" mb="13px">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.416 5.25759L6.67448 13.9991L2.66797 9.99257L3.69509 8.96544L6.67448 11.9375L14.3888 4.23047L15.416 5.25759Z" fill="#0C0C0D" />
                                </svg>
                                <Typography color='#111111' fontSize="13px" fontWeight="700">Up to 30 minutes/webinar</Typography>

                            </Box>
                            <Box display="flex" gap="10px" mb="13px">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.416 5.25759L6.67448 13.9991L2.66797 9.99257L3.69509 8.96544L6.67448 11.9375L14.3888 4.23047L15.416 5.25759Z" fill="#0C0C0D" />
                                </svg>
                                <Typography color='#111111' fontSize="13px" fontWeight="700">7 days of video recording storage</Typography>
                            </Box>
                            <Box display="flex" gap="10px" mb="13px">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.416 5.25759L6.67448 13.9991L2.66797 9.99257L3.69509 8.96544L6.67448 11.9375L14.3888 4.23047L15.416 5.25759Z" fill="#0C0C0D" />
                                </svg>
                                <Typography color='#111111' fontSize="13px" fontWeight="700">Number of presenters - 1</Typography>
                            </Box>
                            <Box display="flex" gap="10px" mb="13px">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.416 5.25759L6.67448 13.9991L2.66797 9.99257L3.69509 8.96544L6.67448 11.9375L14.3888 4.23047L15.416 5.25759Z" fill="#0C0C0D" />
                                </svg>
                                <Typography color='#111111' fontSize="13px" fontWeight="700">Chat support</Typography>
                            </Box>
                            <Box display="flex" gap="10px" mb="13px">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.416 5.25759L6.67448 13.9991L2.66797 9.99257L3.69509 8.96544L6.67448 11.9375L14.3888 4.23047L15.416 5.25759Z" fill="#0C0C0D" />
                                </svg>
                                <Typography color='#111111' fontSize="13px" fontWeight="700">Validity - 14 days</Typography>
                            </Box>
                        </Box>
                    </Box>
                    {/* carousel Section */}
                    <Box
                        sx={{
                            overflow: "hidden",
                            width: { xs: "100%", sm: "80%" },
                            margin: "auto",
                            padding: "24px 0 0",
                            "@media (max-width: 768px)": {
                                width: "80%"
                            },
                            "@media (max-width: 600px)": {
                                width: "100%"
                            }
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                transform: `translateX(-${currentIndex * 92}%)`,
                                transition: "transform 0.5s ease-in-out",
                                width: "100%"
                            }}
                        >
                            {cards.map((card, index) => (
                                <Box key={index} sx={{ minWidth: { xs: "92%" }, }}>
                                    <Box
                                        sx={{
                                            backgroundColor: index !== currentIndex ? "#333333" : "#000000",
                                            color: "#fff",
                                            padding: { xs: "20px", sm: "18px 44px 22px 35px" },
                                            borderRadius: "9px",
                                            textAlign: "left",
                                            display: "flex",
                                            marginRight: { xs: "12px", sm: "30px" },
                                            justifyContent: "space-between",
                                            flexDirection: "column",
                                            height: "100%",
                                        }}
                                    >
                                        <Box>
                                            <svg
                                                width="32"
                                                height="25"
                                                viewBox="0 0 32 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M14.2129 0.517682L9.3591 17.3442L7.61172 10.3547C9.76897 10.3547 11.5379 10.9803 12.9186 12.2316C14.2992 13.4828 14.9895 15.2086 14.9895 17.409C14.9895 19.6094 14.2776 21.3783 12.8538 22.7158C11.4732 24.0101 9.72583 24.6573 7.61172 24.6573C5.49762 24.6573 3.72867 24.0101 2.30489 22.7158C0.924245 21.3783 0.233924 19.6094 0.233924 17.409C0.233924 16.8049 0.277069 16.2009 0.363359 15.5969C0.492795 14.9928 0.70852 14.2594 1.01053 13.3965C1.31255 12.5336 1.76557 11.4118 2.3696 10.0312L6.51152 0.517682H14.2129ZM31.1689 0.517682L26.3151 17.3442L24.5677 10.3547C26.725 10.3547 28.4939 10.9803 29.8746 12.2316C31.2552 13.4828 31.9455 15.2086 31.9455 17.409C31.9455 19.6094 31.2336 21.3783 29.8098 22.7158C28.4292 24.0101 26.6818 24.6573 24.5677 24.6573C22.4536 24.6573 20.6847 24.0101 19.2609 22.7158C17.8802 21.3783 17.1899 19.6094 17.1899 17.409C17.1899 16.8049 17.2331 16.2009 17.3194 15.5969C17.4488 14.9928 17.6645 14.2594 17.9665 13.3965C18.2685 12.5336 18.7216 11.4118 19.3256 10.0312L23.4675 0.517682H31.1689Z"
                                                    fill="white"
                                                    fillOpacity="0.2"
                                                />
                                            </svg>
                                            <Typography color='#E6E6E6' fontSize='12px' fontWeight='500'>{card.testimonial}</Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginTop: "6px",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <Box display="flex">
                                                <Avatar
                                                    src={card.avatar}
                                                    alt={card.name}
                                                    sx={{ width: "36px", height: "36px", marginRight: "9px" }}
                                                />
                                                <Box>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "600",
                                                            color: "#FFFFFF",
                                                            fontSize: "12px",
                                                            mb: "2px",
                                                        }}
                                                    >
                                                        {card.name}
                                                    </Typography>
                                                    <Typography color="#E8E8EA" fontSize="11px" sx={{ opacity: "60%" }}>
                                                        {card.title}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <svg width="33" height="26" viewBox="0 0 33 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18.6261 25.1237L23.4799 8.29712L25.2273 15.2866C23.07 15.2866 21.3011 14.661 19.9205 13.4098C18.5398 12.1586 17.8495 10.4328 17.8495 8.2324C17.8495 6.032 18.5614 4.26306 19.9852 2.92556C21.3658 1.63121 23.1132 0.984037 25.2273 0.984037C27.3414 0.984037 29.1104 1.63121 30.5341 2.92556C31.9148 4.26306 32.6051 6.032 32.6051 8.2324C32.6051 8.83643 32.562 9.44046 32.4757 10.0445C32.3462 10.6485 32.1305 11.382 31.8285 12.2449C31.5265 13.1078 31.0734 14.2296 30.4694 15.6102L26.3275 25.1237L18.6261 25.1237ZM1.67012 25.1237L6.52394 8.29712L8.27131 15.2866C6.11406 15.2866 4.34511 14.661 2.96447 13.4098C1.58383 12.1586 0.893512 10.4328 0.893512 8.2324C0.893512 6.032 1.6054 4.26306 3.02919 2.92556C4.40983 1.63121 6.1572 0.984036 8.27131 0.984036C10.3854 0.984036 12.1544 1.63121 13.5781 2.92556C14.9588 4.26306 15.6491 6.032 15.6491 8.2324C15.6491 8.83643 15.606 9.44046 15.5197 10.0445C15.3902 10.6485 15.1745 11.382 14.8725 12.2449C14.5705 13.1078 14.1175 14.2296 13.5134 15.6102L9.37151 25.1237L1.67012 25.1237Z" fill="white" fillOpacity="0.2" />
                                            </svg>
                                        </Box>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "24px",
                            }}
                        >
                            {cards.map((_, index) => (
                                <Box
                                    key={index}
                                    onClick={() => handleDotClick(index)}
                                    sx={{
                                        width: "11px",
                                        height: "11px",
                                        borderRadius: "50%",
                                        border: "1px solid #000000",
                                        backgroundColor: index === currentIndex ? "#000000" : "#D9D9D9",
                                        marginRight: "6px",
                                        cursor: "pointer",
                                    }}
                                />
                            ))}
                        </Box>
                    </Box>
                </Box>
                {/*------------------------steps------------------------*/}
                {step === 1 && (
                    <Box sx={{
                        padding: { xs: '14px 24px', sm: '30px 21px', lg: '49px 66px' }, flex: 1, position: 'relative', '@media (max-width: 768px)': {
                            width: '100%',
                        }
                    }}>
                        <Box
                            sx={{
                                display: "none",
                                "& svg": {
                                    height: "43px",
                                },
                                "@media (max-width: 768px)": {
                                    display: "block",
                                },
                            }}
                        >
                            <EasyWebinarLogo />
                        </Box>
                        <Typography variant="h5" sx={{
                            color: '#333', fontWeight: '700', marginBottom: '10px', textAlign: 'center', lineHeight: '44px', mb: '3px', fontSize: 'min(calc(24px + 5 * (100vw - 400px) / (1920 - 400)), 29px)'
                        }} >
                            Let's get started!
                        </Typography>
                        <Typography sx={{ color: '#333333', marginBottom: '36px', textAlign: 'center', fontSize: '16px', }}>14-day free trial</Typography>
                        <Box sx={{ width: '100%', mb: '34px' }}>
                            <Typography color='#333333' fontSize='14px' mb='4px'>0 of 2 Completed</Typography>
                            <BorderLinearProgress variant="determinate" value={1} />
                        </Box>
                        <Box mb='18px'>
                            <TextField
                                variant="outlined"
                                placeholder='Full Name'
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: '3px',
                                        borderColor: '#C7C7C7',
                                        background: "#ffffff"
                                    },

                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: '#333333',
                                        border: '1px solid'
                                    },

                                    "& .MuiOutlinedInput-input": {
                                        padding: '11px 11px 11px 0px',
                                        background: '#ffffff',
                                        borderRadius: '8px'
                                    },
                                    "&.MuiInputBase-input::placeholder": {
                                        color: '#333333',
                                        fontSize: '16px',
                                        opacity: '0.8'
                                    },
                                }}
                                slotProps={{
                                    input: {
                                        startAdornment: <InputAdornment position="start"><NameIcon />
                                        </InputAdornment>,
                                    },
                                }}
                                fullWidth
                            />
                        </Box>
                        <Box mb='18px'>
                            <TextField
                                variant="outlined"
                                placeholder='Email'
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: '3px',
                                        borderColor: '#C7C7C7',
                                        background: "#ffffff"
                                    },

                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: '#333333',
                                        border: '1px solid'
                                    },

                                    "& .MuiOutlinedInput-input": {
                                        padding: '11px 11px 11px 0px',
                                        background: '#ffffff',
                                        borderRadius: '8px'
                                    },
                                    "&.MuiInputBase-input::placeholder": {
                                        color: '#333333',
                                        fontSize: '16px',
                                        opacity: '0.8'
                                    },
                                }}
                                slotProps={{
                                    input: {
                                        startAdornment: <InputAdornment position="start"><EmailIcon />
                                        </InputAdornment>,
                                    },
                                }}
                                fullWidth
                            />
                        </Box>
                        <Box mb='18px'>
                            <MuiPhone
                                value={phone}
                                onChange={handlePhoneChange}
                                fullWidth
                            />
                        </Box>
                        <Box mb='18px'>
                            <TextField
                                variant="outlined"
                                placeholder='Password'
                                type={showPassword ? 'text' : 'password'}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: '3px',
                                        borderColor: '#C7C7C7',
                                        background: '#ffffff',
                                        paddingRight: '0'
                                    },

                                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: '#333333',
                                        border: '1px solid'
                                    },

                                    "& .MuiOutlinedInput-input": {
                                        padding: '11px 11px 11px 0px',
                                        background: '#ffffff',
                                        borderRadius: '8px'
                                    },
                                    "&.MuiInputBase-input::placeholder": {
                                        color: '#333333',
                                        fontSize: '16px',
                                        opacity: '0.8'
                                    },
                                }}
                                slotProps={{
                                    input: {
                                        endAdornment: <InputAdornment position="start"><IconButton onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            onMouseUp={handleMouseUpPassword}  >
                                            {showPassword ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M12.0001 20.27C15.5301 20.27 18.8201 18.19 21.1101 14.59C22.0101 13.18 22.0101 10.81 21.1101 9.39997C18.8201 5.79997 15.5301 3.71997 12.0001 3.71997C8.47009 3.71997 5.18009 5.79997 2.89009 9.39997C1.99009 10.81 1.99009 13.18 2.89009 14.59C5.18009 18.19 8.47009 20.27 12.0001 20.27Z" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                                : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.5299 9.47004L9.46992 14.53C8.81992 13.88 8.41992 12.99 8.41992 12C8.41992 10.02 10.0199 8.42004 11.9999 8.42004C12.9899 8.42004 13.8799 8.82004 14.5299 9.47004Z" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M17.8201 5.76998C16.0701 4.44998 14.0701 3.72998 12.0001 3.72998C8.47009 3.72998 5.18009 5.80998 2.89009 9.40998C1.99009 10.82 1.99009 13.19 2.89009 14.6C3.68009 15.84 4.60009 16.91 5.60009 17.77" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8.41992 19.5301C9.55992 20.0101 10.7699 20.2701 11.9999 20.2701C15.5299 20.2701 18.8199 18.1901 21.1099 14.5901C22.0099 13.1801 22.0099 10.8101 21.1099 9.40005C20.7799 8.88005 20.4199 8.39005 20.0499 7.93005" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M9.47 14.53L2 22" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M22 2L14.53 9.47" stroke="#BABABA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            }
                                        </IconButton>
                                        </InputAdornment>,
                                        startAdornment: <InputAdornment position="start"><Box display={"flex"} onClick={handleClickShowPassword}
                                            onMouseDown={() => handleMouseDownPassword}
                                            onMouseUp={() => handleMouseUpPassword}  >
                                            <ProtectionIcon />
                                        </Box>
                                        </InputAdornment>
                                    },
                                }}
                                fullWidth
                            />
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center" mb="25px">
                            <Button variant="contained" className="x-large-btn" disableElevation sx={{
                                textTransform: "capitalize", px: "63px", height: "47px!important", '&:hover': {
                                    backgroundColor: '#1fbf62'
                                }
                            }} onClick={() => {
                                handleNext();
                            }}>
                                Next
                            </Button>
                            <AccountVerification
                                onClose={handleDialogClose}
                                open={dialogOpen}
                                onProceed={handleProceed}
                            />
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" mb="22px">
                            <Typography sx={{ color: '#667085', fontsize: '15px', mb: "14px" }}>Or sign up with</Typography>
                            <Box display="flex" gap="13px" mb="14px" flexWrap="wrap" sx={{ cursor: "pointer" }} justifyContent={{ xs: "center", sm: "unset" }}>
                                <Box border="1px solid #D0D5DD" padding="11px" borderRadius="3px" height="37px" width="95px" display="flex" justifyContent="center" alignItems="center" gap="5px">
                                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.9851 5.8796H12.5242V5.85585H7.37389V8.14486H10.608C10.1362 9.47735 8.86833 10.4339 7.37389 10.4339C5.47773 10.4339 3.94038 8.89651 3.94038 7.00035C3.94038 5.1042 5.47773 3.56684 7.37389 3.56684C8.24915 3.56684 9.04544 3.89703 9.65174 4.43638L11.2704 2.81776C10.2483 1.86525 8.8812 1.27783 7.37389 1.27783C4.21363 1.27783 1.65137 3.84009 1.65137 7.00035C1.65137 10.1606 4.21363 12.7229 7.37389 12.7229C10.5342 12.7229 13.0964 10.1606 13.0964 7.00035C13.0964 6.61666 13.0569 6.24212 12.9851 5.8796Z" fill="#FFC107" />
                                        <path d="M2.31055 4.33681L4.19068 5.71565C4.69941 4.45612 5.93147 3.56684 7.37326 3.56684C8.24852 3.56684 9.04481 3.89703 9.65111 4.43638L11.2697 2.81776C10.2477 1.86525 8.88057 1.27783 7.37326 1.27783C5.17524 1.27783 3.26907 2.51876 2.31055 4.33681Z" fill="#FF3D00" />
                                        <path d="M7.3728 12.7232C8.85092 12.7232 10.194 12.1575 11.2095 11.2376L9.43834 9.73892C8.8445 10.1905 8.11886 10.4348 7.3728 10.4342C5.88437 10.4342 4.62055 9.48512 4.14443 8.16064L2.27832 9.59843C3.2254 11.4517 5.14874 12.7232 7.3728 12.7232Z" fill="#4CAF50" />
                                        <path d="M12.9852 5.88019H12.5243V5.85645H7.37402V8.14545H10.6081C10.3824 8.77963 9.97587 9.33379 9.43871 9.73946L9.43957 9.73889L11.2107 11.2376C11.0854 11.3515 13.0965 9.86221 13.0965 7.00095C13.0965 6.61725 13.0571 6.24272 12.9852 5.88019Z" fill="#1976D2" />
                                    </svg>
                                    <Typography color='#0C141D' fontSize='12px'>Google</Typography>
                                </Box>
                                <Box border="1px solid #D0D5DD" padding="11px" sx={{ cursor: "pointer" }} borderRadius="3px" height="37px" width="95px" display="flex" justifyContent="center" alignItems="center" gap="5px">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_1886_2983)">
                                            <path d="M12.9838 0.133789H0.765868C0.564819 0.133789 0.372005 0.213655 0.229842 0.355818C0.0876788 0.497981 0.0078125 0.690796 0.0078125 0.891844L0.0078125 13.1098C0.0078125 13.3108 0.0876788 13.5036 0.229842 13.6458C0.372005 13.788 0.564819 13.8678 0.765868 13.8678H7.34426V8.55663H5.56045V6.47774H7.34426V4.94875C7.34426 3.17486 8.4277 2.20892 10.0106 2.20892C10.7684 2.20892 11.42 2.26525 11.6093 2.28939V4.14322H10.5176C9.65652 4.14322 9.48967 4.55229 9.48967 5.15289V6.47774H11.5482L11.2799 8.55663H9.48967V13.8678H12.9833C13.0829 13.8679 13.1815 13.8484 13.2735 13.8103C13.3656 13.7722 13.4492 13.7164 13.5196 13.646C13.5901 13.5756 13.646 13.492 13.6841 13.4C13.7222 13.308 13.7419 13.2094 13.7419 13.1098V0.891844C13.7419 0.690796 13.662 0.497981 13.5198 0.355818C13.3777 0.213655 13.1849 0.133789 12.9838 0.133789Z" fill="#4267B2" />
                                            <path d="M9.49031 13.8681V8.55691H11.2808L11.5491 6.47803H9.49031V5.15398C9.49031 4.55338 9.65662 4.14431 10.5182 4.14431H11.6094V2.28995C11.4195 2.26473 10.768 2.20947 10.0107 2.20947C8.42807 2.20947 7.34436 3.17515 7.34436 4.94931V6.47829H5.56055V8.55691H7.34436V13.8681H9.49031Z" fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1886_2983">
                                                <rect width="13.7341" height="13.7341" fill="white" transform="translate(0.0078125 0.133789)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <Typography color='#0C141D' fontSize='12px'>Facebook</Typography>
                                </Box>
                                <Box border="1px solid #D0D5DD" sx={{ cursor: "pointer" }} padding="11px" borderRadius="3px" height="37px" width="95px" display="flex" justifyContent="center" alignItems="center" gap="5px">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_1886_2988)">
                                            <path d="M12.4527 0.455616H1.2938C1.04061 0.453039 0.796743 0.551008 0.615702 0.728025C0.434661 0.905043 0.331238 1.14665 0.328125 1.39983V12.6038C0.331801 12.8566 0.435472 13.0977 0.616451 13.2742C0.79743 13.4508 1.04098 13.5485 1.2938 13.5459H12.4527C12.7059 13.5479 12.9496 13.4496 13.1306 13.2725C13.3115 13.0953 13.415 12.8538 13.4184 12.6006V1.39661C13.4139 1.14417 13.3099 0.903718 13.1291 0.727513C12.9483 0.551309 12.7052 0.453596 12.4527 0.455616Z" fill="#0076B2" />
                                            <path d="M2.26584 5.36211H4.20899V11.6143H2.26584V5.36211ZM3.23795 2.25049C3.46082 2.25049 3.67868 2.31659 3.86398 2.44043C4.04927 2.56428 4.19368 2.74029 4.27892 2.94622C4.36415 3.15214 4.3864 3.37873 4.34284 3.5973C4.29929 3.81587 4.19188 4.01661 4.03421 4.17413C3.87654 4.33165 3.6757 4.43886 3.45708 4.48221C3.23847 4.52556 3.01191 4.5031 2.80607 4.41766C2.60022 4.33223 2.42434 4.18766 2.30068 4.00225C2.17701 3.81683 2.11112 3.59891 2.11133 3.37604C2.11161 3.07742 2.23044 2.79114 2.44169 2.58009C2.65294 2.36904 2.93934 2.25049 3.23795 2.25049ZM5.42789 5.36211H7.29057V6.22049H7.31632C7.57598 5.72907 8.20903 5.21082 9.15432 5.21082C11.1222 5.20653 11.487 6.50161 11.487 8.18081V11.6143H9.54381V8.57244C9.54381 7.84819 9.53094 6.91577 8.53414 6.91577C7.53735 6.91577 7.36782 7.70548 7.36782 8.52523V11.6143H5.42789V5.36211Z" fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1886_2988">
                                                <rect width="13.7341" height="13.7341" fill="white" transform="translate(0.00585938 0.133789)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <Typography color='#0C141D' fontSize='12px'>LinkedIn</Typography>
                                </Box>
                                <Box border="1px solid #D0D5DD" sx={{ cursor: "pointer" }} padding="11px" borderRadius="3px" height="37px" width="95px" display="flex" justifyContent="center" alignItems="center" gap="5px">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_1886_2993)">
                                            <path d="M6.53112 6.661H0.00390625V0.133789H6.53112V6.661Z" fill="#F1511B" />
                                            <path d="M13.7381 6.661H7.21094V0.133789H13.7381V6.661Z" fill="#80CC28" />
                                            <path d="M6.53096 13.868H0.00390625V7.34082H6.53096V13.868Z" fill="#00ADEF" />
                                            <path d="M13.7381 13.868H7.21094V7.34082H13.7381V13.868Z" fill="#FBBC09" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1886_2993">
                                                <rect width="13.7341" height="13.7341" fill="white" transform="translate(0.00390625 0.133789)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <Typography color='#0C141D' fontSize='12px'>Microsoft</Typography>
                                </Box>
                            </Box>
                            <Typography fontWeight="500" color="#667085" textAlign={{ xs: "center", sm: "unset" }}>Already have an account?<Link href="#" sx={{ color: "#635AFF", fontSize: "15px", textDecoration: "none", ml: "4px" }}>Login</Link></Typography>
                        </Box>
                        <Box className="login-authenticator-wrapper" sx={{ position: "unset!important" }}>
                            <Box
                                className="ew-copyright"
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: { xs: "20px", md: "unset" },
                                    justifyContent: { xs: "center" },
                                    alignItems: 'center',
                                    padding: '0 !important',
                                    position: "absolute!important",
                                    margin: { xs: "0!important" },
                                    bottom: '20px!important',
                                    "@media (max-width: 768px)": {
                                        position: "unset!important",
                                    },
                                }}
                            >
                                <Typography
                                    component="span"
                                    sx={{ paddingRight: "13px !important", fontWeight: "500", color: "#667085!important" }}
                                >
                                    &copy; 2025 All Rights Reserved
                                </Typography>
                                <Box
                                    component="ul"
                                    sx={{
                                        display: 'flex',
                                        listStyle: 'none',
                                        margin: 0,
                                        padding: 0,
                                        gap: { xs: "20px", md: "4px" },
                                        position: 'relative',
                                        flexWrap: 'wrap',
                                        justifyContent: { xs: "center", sm: "unset" },
                                    }}
                                >
                                    <Box
                                        component="li"
                                    >
                                        <Link
                                            href="#"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className='terms'
                                            sx={{
                                                textDecoration: 'none',
                                                color: "#667085 !important",
                                                fontSize: '13px !important',
                                                lineHeight: 'unset !important',
                                                fontWeight: "500",
                                                marginRight: "4px",
                                                paddingLeft: { xs: "0", sm: "unset" },
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },

                                            }}
                                        >
                                            Terms of Service
                                        </Link>
                                    </Box>
                                    <Box
                                        component="li"
                                    >
                                        <Link
                                            href="#"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                textDecoration: 'none',
                                                color: "#667085!important",
                                                fontWeight: "500",
                                                marginRight: "4px",
                                                fontSize: '13px !important',
                                                lineHeight: 'unset !important',
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },
                                            }}
                                        >
                                            Privacy Policy
                                        </Link>
                                    </Box>
                                    <Box
                                        component="li"
                                    >
                                        <Link
                                            href="#"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                textDecoration: 'none',
                                                color: "#667085!important",
                                                fontSize: '13px !important',
                                                lineHeight: 'unset !important',
                                                fontWeight: "500",
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },
                                            }}
                                        >
                                            Security
                                        </Link>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
                {step === 2 && (
                    <Box sx={{
                        padding: { xs: '14px 24px', sm: '30px 21px', lg: '49px 66px' }, flex: 1, position: 'relative', '@media (max-width: 768px)': {
                            width: '100%',
                        }
                    }} display="flex" flexDirection="column" justifyContent="space-between">
                        <Box>
                            <Box
                                sx={{
                                    display: "none",
                                    "& svg": {
                                        height: "43px",
                                    },
                                    "@media (max-width: 768px)": {
                                        display: "block",
                                    },

                                }}
                            >
                                <EasyWebinarLogo />
                            </Box>
                            <Typography variant="h5" sx={{ color: '#333', fontWeight: '700', fontSize: 'min(calc(24px + 5 * (100vw - 400px) / (1920 - 400)), 29px)', marginBottom: '10px', textAlign: 'center', mb: { xs: "10px", sm: "3px" } }}>
                                You are almost there...
                            </Typography>
                            <Box className="login-authenticator-wrapper">
                                <Box
                                    className="ew-copyright"
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: { xs: "20px", md: "unset" },
                                        justifyContent: { xs: "center" },
                                        alignItems: 'center',
                                        padding: '0 !important',
                                        position: 'unset!important',
                                        mx: '0px!important',

                                    }}
                                >
                                    <Box
                                        component="ul"
                                        sx={{
                                            display: 'flex',
                                            listStyle: 'none',
                                            margin: 0,
                                            padding: 0,
                                            gap: '4px',
                                            position: 'relative',
                                        }}
                                    >
                                        <Box
                                            component="li"
                                            sx={{ paddingLeft: "0!important" }}
                                        >
                                            <Link
                                                href="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className='terms'
                                                sx={{
                                                    textDecoration: 'none',
                                                    color: "#333333!important",
                                                    fontSize: '16px!important',
                                                    marginRight: "4px",
                                                    '&:hover': {
                                                        textDecoration: 'underline',
                                                    },

                                                }}
                                            >
                                                Engage
                                            </Link>
                                        </Box>
                                        <Box
                                            component="li"
                                        >
                                            <Link
                                                href="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    textDecoration: 'none',
                                                    color: "#333333!important",
                                                    fontSize: '16px!important',
                                                    marginRight: "4px",
                                                    '&:hover': {
                                                        textDecoration: 'underline',
                                                    },
                                                }}
                                            >
                                                Educate
                                            </Link>
                                        </Box>
                                        <Box
                                            component="li"
                                        >
                                            <Link
                                                href="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                sx={{
                                                    textDecoration: 'none',
                                                    color: "#333333!important",
                                                    fontSize: '16px!important',
                                                    '&:hover': {
                                                        textDecoration: 'underline',
                                                    },
                                                }}
                                            >
                                                Elevate
                                            </Link>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                            <Box sx={{ width: '100%', mb: '36px' }}>
                                <Typography color='#333333' fontSize='14px' mb='4px'>1 of 2 Completed</Typography>
                                <BorderLinearProgress variant="determinate" value={step === 2 ? 50 : 100} />
                            </Box>
                            <Box mb="14px">
                                <Typography color='#667085' fontSize='15px' marginBottom="18px">Your Domain URL is</Typography>
                                <TextField
                                    variant="outlined"
                                    placeholder="Example"
                                    sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: '3px',
                                            borderColor: '#C7C7C7',
                                            background: '#ffffff',
                                            paddingRight: '0'
                                        },

                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: '#333333',
                                            border: '1px solid'
                                        },

                                        "& .MuiOutlinedInput-input": {
                                            padding: '11px 14px',
                                            background: '#ffffff',
                                            borderRadius: '8px'
                                        },
                                        "&.MuiInputBase-input::placeholder": {
                                            color: '#333333',
                                            fontSize: '16px',
                                            opacity: '0.8'
                                        },
                                    }}
                                    slotProps={{
                                        input: {
                                            endAdornment: (
                                                <InputAdornment
                                                    position="end"
                                                    sx={{
                                                        ".MuiTypography-root": {
                                                            color: "#333333",
                                                            fontWeight: "500",
                                                            fontSize: "16px",
                                                        },

                                                        paddingRight: "19px",
                                                    }}
                                                >
                                                    .easywebinar.live
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                />
                            </Box>
                            <FormControlLabel
                                sx={{
                                    fontSize: "14px",
                                    color: "#333333",
                                }}
                                control={
                                    <BpCheckbox sx={{
                                        '& + span': {
                                            ml: '3px'
                                        }
                                    }} />
                                }
                                label={
                                    <Typography fontWeight="500" color="#707070" fontSize="14px">
                                        I have read and agree to all
                                        <Typography display="inline" color="#22B060" fontSize="14px" ml="4px">
                                            Terms and services
                                        </Typography>
                                    </Typography>
                                }
                            />
                            <Box display="flex" gap={{ xs: "13px", sm: "119px" }} justifyContent="center" alignItems="center" mt={{ xs: "20px", md: '56px' }}>
                                <Button variant="outlined" disableElevation sx={{
                                    textTransform: "capitalize", px: "44px", height: "47px!important", border: "1px solid #D0D5DD", color: "#0C141D", fontSize: "18px", '&:hover': {
                                        backgroundColor: '#fff'
                                    }
                                }} onClick={handleBack}>
                                    Back
                                </Button>
                                <Button variant="contained" className="x-large-btn" disableElevation sx={{
                                    textTransform: "capitalize", px: "44px", height: "47px!important", fontSize: "18px", '&:hover': {
                                        backgroundColor: '#1fbf62'
                                    }
                                }} onClick={handleNext}>
                                    Submit
                                </Button>
                            </Box>
                        </Box>
                        <Box className="login-authenticator-wrapper" sx={{ position: "unset!important" }} mt={{ xs: "11px", md: "32px" }}>
                            <Box
                                className="ew-copyright"
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: { xs: "20px", md: "unset" },
                                    justifyContent: { xs: "center" },
                                    alignItems: 'center',
                                    padding: '0 !important',
                                    position: 'relative !important',
                                    margin: { xs: "30px 0 !important", md: "13px 0 !important" },
                                    bottom: 'unset !important',
                                    "@media (max-width: 900px)": {
                                        position: "unset !important",
                                        bottom: "unset",
                                    },
                                }}
                            >
                                <Typography
                                    component="span"
                                    sx={{ paddingRight: "13px !important", fontWeight: "500", color: "#667085!important" }}
                                >
                                    &copy; 2025 All Rights Reserved
                                </Typography>
                                <Box
                                    component="ul"
                                    sx={{
                                        display: 'flex',
                                        listStyle: 'none',
                                        margin: 0,
                                        padding: 0,
                                        gap: '4px',
                                        position: 'relative',
                                        flexWrap: 'wrap',
                                        justifyContent: { xs: "center", sm: "unset" },
                                    }}
                                >
                                    <Box
                                        component="li"
                                        paddingLeft={{ xs: "0!important", sm: '10px!important' }}

                                    >
                                        <Link
                                            href="#"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className='terms'
                                            sx={{
                                                textDecoration: 'none',
                                                color: "#667085!important",
                                                fontSize: '13px !important',
                                                lineHeight: 'unset !important',
                                                fontWeight: "500",
                                                marginRight: "4px",
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },

                                            }}
                                        >
                                            Terms of Service
                                        </Link>
                                    </Box>
                                    <Box
                                        component="li"
                                        paddingLeft={{ xs: "5px!important", sm: '10px!important' }}
                                    >
                                        <Link
                                            href="#"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                textDecoration: 'none',
                                                color: "#667085!important",
                                                fontSize: '13px !important',
                                                lineHeight: 'unset !important',
                                                fontWeight: "500",
                                                marginRight: "4px",
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },
                                            }}
                                        >
                                            Privacy Policy
                                        </Link>
                                    </Box>
                                    <Box
                                        component="li"
                                        paddingLeft={{ xs: "5px!important", sm: '10px!important' }}
                                    >
                                        <Link
                                            href="#"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                textDecoration: 'none',
                                                color: "#667085!important",
                                                fontSize: '13px !important',
                                                lineHeight: 'unset !important',
                                                fontWeight: "500",
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },
                                            }}
                                        >
                                            Security
                                        </Link>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
                {step === 3 && (
                    <Box sx={{
                        padding: { xs: '14px 24px', sm: '30px 21px', lg: '49px 66px' }, justifyContent: 'space-between', display: 'flex', flexDirection: 'column', flex: 1, position: 'relative', width: '50%', '@media (max-width: 768px)': {
                            width: '100%',
                        }
                    }}>
                        <Box>
                            <Typography variant="h5" sx={{ color: '#333', fontWeight: '700', fontSize: 'min(calc(24px + 5 * (100vw - 400px) / (1920 - 400)), 29px)', marginBottom: '10px', textAlign: 'center', lineHeight: '44px', mb: '28px' }}>
                                We’re done!
                            </Typography>
                            <Box sx={{ width: '100%', mb: '40px' }}>
                                <Typography color='#333333' fontSize='14px' mb='4px'>2 of 2 Completed</Typography>
                                <BorderLinearProgress variant="determinate" value={step === 3 ? 100 : 0} />
                            </Box>
                            <Box padding={{ xs: "11px", sm: "56px" }} display='flex' justifyContent='center' alignItems='center' flexDirection='column' sx={{
                                'img': {
                                    height: "38px",
                                    width: "38px",
                                }
                            }}>
                                <img src={loader} />
                                <Typography color='#6C6C6C' fontSize='20px' fontWeight='500'>Redirecting</Typography>
                            </Box>
                        </Box>
                        <Box className="login-authenticator-wrapper" sx={{ position: "unset!important" }} mt={{ xs: "11px", md: "32px" }}>
                            <Box
                                className="ew-copyright"
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: { xs: "20px", md: "unset" },
                                    justifyContent: { xs: "center" },
                                    alignItems: 'center',
                                    padding: '0 !important',
                                    position: 'relative !important',
                                    margin: { xs: "30px 0 0 0 !important", md: "13px 0 !important" },
                                    bottom: 'unset !important',
                                    "@media (max-width: 900px)": {
                                        position: "unset !important",
                                        bottom: "unset",
                                    },
                                }}
                            >
                                <Typography
                                    component="span"
                                    sx={{ paddingRight: "13px !important", fontWeight: "500", color: "#667085!important" }}
                                >
                                    &copy; 2025 All Rights Reserved
                                </Typography>
                                <Box
                                    component="ul"
                                    sx={{
                                        display: 'flex',
                                        listStyle: 'none',
                                        margin: 0,
                                        padding: 0,
                                        gap: '4px',
                                        position: 'relative',
                                        flexWrap: 'wrap',
                                        justifyContent: { xs: "center", sm: "unset" },
                                    }}
                                >
                                    <Box
                                        component="li"
                                        paddingLeft={{ xs: "0!important", sm: '10px!important' }}

                                    >
                                        <Link
                                            href="#"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className='terms'
                                            sx={{
                                                textDecoration: 'none',
                                                color: "#667085!important",
                                                fontSize: '13px !important',
                                                lineHeight: 'unset !important',
                                                fontWeight: "500",
                                                marginRight: "4px",
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },

                                            }}
                                        >
                                            Terms of Service
                                        </Link>
                                    </Box>
                                    <Box
                                        component="li"
                                        paddingLeft={{ xs: "5px!important", sm: '10px!important' }}
                                    >
                                        <Link
                                            href="#"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                textDecoration: 'none',
                                                color: "#667085!important",
                                                fontSize: '13px !important',
                                                lineHeight: 'unset !important',
                                                fontWeight: "500",
                                                marginRight: "4px",
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },
                                            }}
                                        >
                                            Privacy Policy
                                        </Link>
                                    </Box>
                                    <Box
                                        component="li"
                                        paddingLeft={{ xs: "5px!important", sm: '10px!important' }}
                                    >
                                        <Link
                                            href="#"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                textDecoration: 'none',
                                                color: "#667085!important",
                                                fontSize: '13px !important',
                                                lineHeight: 'unset !important',
                                                fontWeight: "500",
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },
                                            }}
                                        >
                                            Security
                                        </Link>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </Box>
        </Box >
    );
}
export default EasyWebinarsignUp;

